<template>
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content mobile-dialog'>
            <div class='confirm-dlg-box'>
                <div class='confirm-dlg-title'>{{title}}</div>
                <div class='confirm-dlg-content'>{{content}}</div>
            </div>
            <div style='display: flex'>
              <button class="mobile-dlg-btn" @click="onClosePop">취소</button>
              <button class="mobile-dlg-btn active" @click="onConfirmPop">확인</button>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  name: 'ConfirmDlg',
  components: { LoadingSpinner },
  props: {
    title: String,
    content: String,
    show: Boolean,
      onCancel: Function,
      onConfirm: Function,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    init(){

    },

    onConfirmPop(){
        this.onConfirm();
    },

    onClosePop() {
      this.onCancel();
    },
  },
};
</script>